import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_ProviderSummaryCard = _resolveComponent("ProviderSummaryCard")!
  const _component_ProviderCard = _resolveComponent("ProviderCard")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ConfigCardOverlay = _resolveComponent("ConfigCardOverlay")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "my-0 ml-0 mr-n2 pa-0",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            class: "ma-0 pa-2"
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        density: "compact",
        class: "ma-0 pa-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            density: "compact",
            class: "ma-0 pa-2 d-flex align-center"
          }, {
            default: _withCtx(() => [
              (_ctx.count > 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    buttonClass: "ml-1",
                    icon: "mdi-plus",
                    click: _ctx.openCreateProviderOverlay,
                    size: "x-large",
                    tooltip: "New Provider",
                    variant: "outlined",
                    density: "default",
                    color: "secondary"
                  }, null, 8, ["click"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_tooltip, {
                text: "Refresh Providers",
                location: "top"
              }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn, _mergeProps(props, {
                    color: "primary",
                    variant: "text",
                    icon: "",
                    loading: _ctx.refreshingProviders,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshProviders(true, 'manual')))
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("mdi-refresh")
                        ])),
                        _: 1,
                        __: [3]
                      })
                    ]),
                    _: 2
                  }, 1040, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.providerKeys != null)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            density: "compact",
            class: "ma-0 pa-0"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providerKeys, (providerKey) => {
                return (_openBlock(), _createBlock(_component_v_col, {
                  key: providerKey,
                  cols: _ctx.isDesktop ? 4 : 12,
                  class: "ma-0 pa-2"
                }, {
                  default: _withCtx(() => [
                    (_ctx.isDesktop)
                      ? (_openBlock(), _createBlock(_component_ProviderSummaryCard, {
                          key: 0,
                          providerKey: providerKey,
                          onEdit: _ctx.openEditProviderOverlay
                        }, null, 8, ["providerKey", "onEdit"]))
                      : (_openBlock(), _createBlock(_component_ProviderCard, {
                          key: 1,
                          providerKey: providerKey,
                          showTips: _ctx.showTips,
                          startExpanded: providerKey === _ctx.expandedProviderKey,
                          onSaved: _ctx.handleProviderSaved
                        }, null, 8, ["providerKey", "showTips", "startExpanded", "onSaved"]))
                  ]),
                  _: 2
                }, 1032, ["cols"]))
              }), 128)),
              (_ctx.count === 0)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: _ctx.isDesktop ? 4 : 12,
                    class: "ma-0 pa-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        onClick: _ctx.openCreateProviderOverlay,
                        class: "ma-0 pa-2 card add-card",
                        color: "surface",
                        density: "compact",
                        variant: "elevated",
                        elevation: "4",
                        "min-height": "350"
                      }, {
                        default: _withCtx(() => [
                          _cache[4] || (_cache[4] = _createElementVNode("p", null, "New provider", -1)),
                          _createVNode(_component_v_icon, {
                            class: "add-icon",
                            icon: "mdi-plus"
                          })
                        ]),
                        _: 1,
                        __: [4]
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["cols"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ConfigCardOverlay, {
        modelValue: _ctx.showCreateProviderOverlay,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showCreateProviderOverlay) = $event)),
        title: "New Provider",
        onClose: _ctx.closeCreateProviderOverlay
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ProviderCard, {
            isOverlay: "",
            showTips: _ctx.showTips,
            onRemoveCard: _ctx.closeCreateProviderOverlay,
            onSaved: _ctx.handleProviderSaved
          }, null, 8, ["showTips", "onRemoveCard", "onSaved"])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"]),
      _createVNode(_component_ConfigCardOverlay, {
        modelValue: _ctx.showEditProviderOverlay,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showEditProviderOverlay) = $event)),
        title: "Edit Provider",
        onClose: _ctx.closeEditProviderOverlay
      }, {
        default: _withCtx(() => [
          (_ctx.editingProviderKey)
            ? (_openBlock(), _createBlock(_component_ProviderCard, {
                key: 0,
                providerKey: _ctx.editingProviderKey,
                isOverlay: "",
                showTips: _ctx.showTips,
                startExpanded: true,
                onRemoveCard: _ctx.closeEditProviderOverlay,
                onSaved: _ctx.handleProviderSaved
              }, null, 8, ["providerKey", "showTips", "onRemoveCard", "onSaved"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"])
    ]),
    _: 1
  }))
}